function faq() {
  const sections = document.querySelectorAll('.section-faq');

  const toggleFaq = (body, icon) => {
    if (body.getBoundingClientRect().height > 0) {
      body.style.height = '0px';
      icon.classList.remove('active');
    } else {
      const bodyHeight = body.firstElementChild.getBoundingClientRect().height;
      body.style.height = `${bodyHeight}px`;
      icon.classList.add('active');
    }
  };

  const ro = new ResizeObserver((entries) => {
    for (let entry of entries) {
      const { target } = entry;
      const body = target.parentElement;
      const button = body.previousElementSibling;

      if (button?.children[1].classList[1] !== 'active') return;
      body.style.height = `${target.getBoundingClientRect().height}px`;
    }
  });

  sections.forEach((section) => {
    const listItems = section.querySelectorAll('li.section-faq__list-item');

    listItems.forEach((listItem) => {
      const button = listItem.querySelector('button');
      if (!button) return;

      const toggleIcon = button.querySelector('.toggle-icon');
      const body = listItem.querySelector('.section-faq__list-item__body');

      const content = body.querySelector('.markdown') || body.firstElementChild;
      if (content) ro.observe(content); 

      button.addEventListener('click', () => toggleFaq(body, toggleIcon));
    });
  });
}
faq();
